var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3.25A2.25 2.25 0 0 1 4.25 1h8.5c.69 0 1.25.56 1.25 1.25V4.5a.75.75 0 0 1-1.5 0v-2H4.25a.75.75 0 0 0-.75.75v6.878q.354-.126.75-.128h.25a.75.75 0 0 1 0 1.5h-.25a.75.75 0 0 0-.75.75v.5c0 .414.336.75.75.75h1a.75.75 0 0 1 0 1.5h-1A2.25 2.25 0 0 1 2 12.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.826 10.826a.6.6 0 0 1 .848 0l.726.725V9a.6.6 0 0 1 1.2 0v2.551l.726-.725a.6.6 0 1 1 .848.848l-1.75 1.75a.6.6 0 0 1-.848 0l-1.75-1.75a.6.6 0 0 1 0-.848"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11 6.05a4.95 4.95 0 1 0 0 9.9 4.95 4.95 0 0 0 0-9.9M7.45 11a3.55 3.55 0 1 1 7.1 0 3.55 3.55 0 0 1-7.1 0",
    clipRule: "evenodd"
  }))));
};
export default SvgDocument;